export const PRISMA_ACCESS_NORMAL_LICENSE = 'GPAASSC';
export const PRISMA_ACCESS_SE_LICENSE = 'SE License';
export const PRISMA_ACCESS_LAB_LICENSE = 'LAB License';
export const PRISMA_ACCESS_EVAL_LICENSE = 'Evaluation License';
export const PRISMA_ACCESS_PRODUCTION_LICENSE = 'Production License';